import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const getFacebookUser = createAsyncThunk('facebook/getUser', async ({ accountId, domainId }) => {
  const response = await fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/facebook/account`);
  return await response.json();
});

export const facebookSlice = createSlice({
  name: 'facebook',
  initialState: {
    user: null,
    loading: null,
    error: null,
  },
  reducers: {
    setFacebookUser: (state, action) => {
      state.user = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFacebookUser.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getFacebookUser.fulfilled, (state, action) => {
        const user = action.payload.facebookAccount;
        state.user = user;
        state.loading = false;
      })
      .addCase(getFacebookUser.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});

export const { setFacebookUser } = facebookSlice.actions;

export default facebookSlice.reducer;
